module.exports = __webpack_public_path__ + "img/select_arrow.6e4985b9.svg";